import { REQUEST_USER_SESSION, RECEIVE_IDENTIFIED_USER, RECEIVE_UNIDENTIFIED_USER } from '../constants/action_types';
import * as api from '../api/api';
import isEmpty from 'lodash/isEmpty';
import { getUser } from "data/account/selectors/user";

const requestUserSession = () => ({
    type: REQUEST_USER_SESSION
});

const receiveIdentifiedUser = (data) => ({
    type: RECEIVE_IDENTIFIED_USER,
    data
});

const receiveUnidentifiedUser = () => ({
    type: RECEIVE_UNIDENTIFIED_USER
});

const fetchUserSession = () => (dispatch, getState) => {
    const user = getUser(getState())

    if(isEmpty(user)) {
        dispatch(requestUserSession());

        return api.fetchUserSession()
            .then(response => {
                if (response.ok) {
                    return response.json();
                }

                return null;
            })
            .then(json => {
                if (!isEmpty(json)) {
                    return dispatch(receiveIdentifiedUser(json.data));
                }

                return dispatch(receiveUnidentifiedUser());
            })
            .catch(error => dispatch(receiveUnidentifiedUser()));
    }
};

export {
    fetchUserSession
};
